export default __webpack_public_path__ + "static/media/confirmation-pole.221115f3.svg";